import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box, IconButton, Stack, Typography, Chip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Tooltip } from "@mui/material";
import { DataGrid, GridToolbarContainer } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useStyles } from "./paymentUpdatesContainerStyles";
import { CommonFilterSidebar, CommonPaginationContainer, CommonSelect, commonToast } from "../common";
import { CommonButton } from "../common/commonButton";
import instance from "../../redux/api";
import { 
  getPayoutSummary,
  Broker,
  SCMTableMaintainance,
  BindingAgreements,
  UniqueCurrencyList,
  CurrencyList, 
  getAllPaymentIds,
  BankList
} from "../../Services/api";
import { getPaginationCount } from "../CashAllocation/utils";
// import { paymentPayoutSummary, setIds } from "../../redux/slice/PayoutSummarySlice";
import { numberFormatter } from '../../utils/generalFunctions'
import "../common/commonPageStyles.css";
import DemoWorkflowNav from "./DemoWorkflowNav";

export const selectStyleObj = {
  border: "1px solid #ccc",
  padding: 2,
  paddingLeft: 16,
  fontSize: 13,
  width: "100%",
  height: 38,
  borderRadius: 5,
};

export const filterInputStyleObj = {
  border: "2px solid #ccc",
  padding: 2,
  paddingLeft: 16,
  fontSize: 13,
  height: 38,
  width: "132%",
  borderRadius: 5,
};

const PayoutSummary = () => {
  const { search } = useLocation();
  const policyNo = new URLSearchParams(search).get("policyNo");
  const fileName = new URLSearchParams(search).get("fileName");
  const paymentType = new URLSearchParams(search).get("paymentType");
  const scmType = new URLSearchParams(search).get("scmType");
  const category = new URLSearchParams(search).get("category");
  // const partner = new URLSearchParams(search).get("partner");
  // const placing_broker = new URLSearchParams(search).get("placing_broker");
  // const overall_status = new URLSearchParams(search).get("overall_status");
  

  const [paginationCount, setPaginationCount] = useState(0);
  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [isClearPerformed, setIsClearPerformed] = useState(false);
  const [selectedRecords, setSelectedRecords] = useState([]);
  const [filterSidebarOpen, setFilterSidebarOpen] = useState(true);

  const [searchFieldParams, setSearchFieldsParams] = useState({
    type_of_payment: paymentType,
    scm_type: scmType,
    category: category,
    policy_no: policyNo,
    bdx_file_name: fileName ?? "",
    payment_id: "",
    partner: "",
    placing_broker: "",
    overall_status: [],
    final_bank:"",
    settlement_currency:"",
  });

  const handleFieldsInputChange = (name, value, reason) => {
    if (!value) {
      handleClearSearchList();
    }
    setSearchFieldsParams({
      ...searchFieldParams,
      [name]: value?.trim(),
    });
  };

  const toggle = useSelector((state) => state.toggleSideMenu);

  const currentSkipNumber = () => {
    return pageState?.page === 1
      ? 0
      : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
  };

  const [pageState, setPageState] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
  });
  
  const [overallStatuses, setOverallStatuses] = useState([]);
  const [brokerData, setBrokerData] = useState([]);
  const [partnerData, setPartnerData] = useState([]);  
  const [bindingAgreementData, setbindingAgreementData] = useState([]);
  const [finalBanks, setFinalBanks] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [paymentID, setPaymentID] = useState([]);

  //styles
  const classes = useStyles();

  const getCurrencies = async () => {
    instance
      .get(`documents/currency_details/`)
      .then((response) => setCurrencies(response?.data ?? []))
      .catch((error) =>
        console.error("Error fetching dropdown values:", error)
      );
  }

  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
    backgroundColor: "#fafafa",
  };

  const paymentTypes = ["Syndicate Payment", "Internal Broking", "MGA Commission", "Rebate"];
  const categories = ['Cash', "Non Cash"];

  const loadPartners = async () => {
    try {
    const response = await instance.get(`${SCMTableMaintainance}`)
      if (response.status === 200) {
        setPartnerData(response?.data ?? []);
      } else {
        setPartnerData([]);
      }
    } catch (error) {
      console.error('API call failed:', error);
    }
  }

  const fetchPaymentIDData = async () => {
    try {
      const response = await instance.get(getAllPaymentIds);
      if (response.status === 200) {
        setPaymentID(response.data.data); // Assuming the API returns an array of payment IDs
      } else {
        setPaymentID([]);
      }
    } catch (error) {
      console.error('API call failed:', error);
      setPaymentID([]);
    }
  };

  const fetchBankData = async () => {
    try {
      const response = await instance.get(BankList);
      if (response.status === 200) {
        setFinalBanks(response?.data?.bank_names ?? []);
      } else {
        setFinalBanks([]);
      }
    } catch (error) {
      console.error('API call failed:', error);
    }
  };

  const fetchBindingAgreementData = async () => {
    try {
      const response = await instance.get(BindingAgreements);
      if (response.status === 200) {
        
        setbindingAgreementData(response.data);
      } else {
        setbindingAgreementData([]);
      }
    } catch (error) {
      console.error('API call failed:', error);
    }
  };

  const searchQueryParams = () => {
    let getsearchQueryParams = "";

    const { type_of_payment, policy_no, bdx_file_name, payment_id, category, scm_type, placing_broker, overall_status, partner,final_bank, settlement_currency } = searchFieldParams;

    if (type_of_payment) {
      getsearchQueryParams = `&type_of_payment=${type_of_payment}`
    }

    if (policy_no) {
      getsearchQueryParams = `${getsearchQueryParams}&certificate_ref=${policy_no}`;
    }

    if (bdx_file_name) {
      getsearchQueryParams = `${getsearchQueryParams}&file_name=${bdx_file_name}`;
    }

    if (payment_id) {
      getsearchQueryParams = `${getsearchQueryParams}&payment_id=${payment_id}`
    }

    if (category) {
      getsearchQueryParams = `${getsearchQueryParams}&category=${category}`
    }

    if (scm_type) {
      getsearchQueryParams = `${getsearchQueryParams}&scm_type=${scm_type}`
    }

    if (placing_broker) {
      getsearchQueryParams = `${getsearchQueryParams}&placing_broker=${placing_broker}`
    }

    if (partner) {
      getsearchQueryParams = `${getsearchQueryParams}&partner=${partner}`
    }

    if (settlement_currency) {
      getsearchQueryParams = `${getsearchQueryParams}&settlement_currency=${settlement_currency}`
    }

    if (final_bank) {
      getsearchQueryParams = `${getsearchQueryParams}&final_bank=${final_bank}`
    }

    if (overall_status?.length) {
      const overallStatusStr = overall_status.join(",");
      getsearchQueryParams = `${getsearchQueryParams}&overall_status=${overallStatusStr}`;
    }

    return getsearchQueryParams;
  }

  const loadSearchTxnData = async () => {
    try {
      let queryParams = `skip=0&pageSize=${pageState?.pageSize}`;

      const getSearchQueryParam = searchQueryParams()
      if (getSearchQueryParam) {
        queryParams = `${queryParams}${getSearchQueryParam}`
      }

      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      const response = await instance.get(`${getPayoutSummary}?${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      setIsSearchPerformed(true);
      setIsClearPerformed(false);

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
          page: 1,  // required for sending skip as 0
        }));
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count ?? 0,
          data: [],
          page: 1,  // required for sending skip as 0
        }));
        setPaginationCount(0);
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));
      setPaginationCount(0);
      console.log("err", err);
    }
  };

  const loadData = async () => {
    try {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      let queryParams = `skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize}`;

      if (isSearchPerformed) {
        const getSearchQueryParam = searchQueryParams();
        if (getSearchQueryParam) {
          queryParams = `${queryParams}${getSearchQueryParam}`;
        }
      } else {
        // If we get information while performing route navigation
        if (!isClearPerformed) {
          if (policyNo) {
            queryParams = `${queryParams}&certificate_ref=${policyNo}`;
            setSearchFieldsParams({ ...searchFieldParams, policy_no: policyNo })
          }

          if (fileName) {
            queryParams = `${queryParams}&file_name=${fileName}`;
            setSearchFieldsParams({ ...searchFieldParams, bdx_file_name: fileName });
          }

          if (paymentType) {
            queryParams = `${queryParams}&type_of_payment=${paymentType}`;
            setSearchFieldsParams({ ...searchFieldParams, type_of_payment: paymentType });
          }
        }
      }

      const response = await instance.get(`${getPayoutSummary}?${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data.data ?? [],
        }));
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      setIsApiProgressBar(false);
      console.error("err", err);
    }
  };

  const handleSelectDropdown = (name, value, reason) => {
    if (reason === "clear") {
      loadData();
    }
    setSearchFieldsParams({
      ...searchFieldParams,
      [name]: value ?? "",
    });
  };

  const handleClearSearchList = async () => {
    setIsSearchPerformed(false);
    setIsClearPerformed(true);
    setSelectedRecords([]);

    // clear fields
    setSearchFieldsParams({
      type_of_payment: "",
      policy_no: "",
      bdx_file_name: "",
      payment_id: "",
      category: "",
      overall_status: [],
      partner: "",
      placing_broker: "",
      scm_type: "",
      final_bank: "",
      settlement_currency: "",
    });
  };

  // const { selectedCheckboxIds, data, isLoading, error } = useSelector((state) => state?.PayoutSummary);

  // const handleRadioChange = (e) => {
  //   const { value, checked } = e.target
    
  //   if(checked)
  //     setSelectedRecords([...selectedRecords, Number(value)])

  //   else
  //     setSelectedRecords([...selectedRecords.filter(record => record !== Number(value))])
  // };

  const handleSelectionModelChange = (e) => {
    // setSelectionModel(newSelectionModel);

    // if (newSelectionModel.length === 0) {
    //   setIsButtonDisabled(true);
    // } else {
    //   setIsButtonDisabled(false);
    // }
    setSelectedRecords(e)
  };

  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [isApiProgressBar, setIsApiProgressBar] = useState(false);
  // DEMO: initiate payment
  const [isInitiatePaymentDialogOpen, setIsInitiatePaymentDialogOpen] = useState(false);

  const handleInitiatePaymentClick = () => {
    // DEMO: initiate payment
    if (selectedRecords?.length === 0) return;
    setIsInitiatePaymentDialogOpen(true);
  };

  const handleConfirmInitiatePayment = () => {
    // DEMO: initiate payment — richer toast with count + total amount
    const count = selectedRecords?.length ?? 0;
    const total = (pageState?.data ?? [])
      .filter((row) => selectedRecords?.includes(row?.id))
      .reduce((sum, row) => {
        const n = Number(row?.sum_of_net_payment);
        return sum + (Number.isFinite(n) ? n : 0);
      }, 0);
    setIsInitiatePaymentDialogOpen(false);
    setSelectedRecords([]);
    commonToast(
      "success",
      `Payment initiated for ${count} item${count === 1 ? "" : "s"} · $${numberFormatter(total)}`,
    );
  };

  const handleCancelInitiatePayment = () => {
    // DEMO: initiate payment
    setIsInitiatePaymentDialogOpen(false);
  };

  // Original initiate payment API kept for reference (demo uses modal + toast only)
  // const handleInitiatePaymentClickApi = () => {
  //   setIsButtonClicked(true);
  //   setIsApiProgressBar(true);
  //   instance.post(`${getPayoutSummary}`,{ids: selectedRecords})
  //   .then((response) => {
  //     handleClearSearchList();
  //     loadData();
  //     setIsButtonClicked(false);
  //     setIsApiProgressBar(false);
  //     setSelectedRecords([]);
  //   })
  //   .catch((error) => {
  //     console.error("Error : ", error)
  //     setIsButtonClicked(false);
  //     setIsApiProgressBar(false);
  //   })
  // };

  // const partnerPaymentColumns = [
  //   {
  //     headerName: "",
  //     headerAlign: "center",
  //     flex: 0.1,
  //     type: "actions",
  //     renderCell: (params) => (
  //       <>
  //         <Checkbox
  //           // checked={selectedCheckboxIds?.includes(params?.row?.id)}
  //           onChange={(e) => handleRadioChange(e)}
  //           value={params?.row?.id}
  //           name="file-selection"
  //           style={{ color: "black" }}
  //         />
  //       </>
  //     ),
  //   },
  //   {
  //     field: "bdx_file_name",
  //     headerName: "BDX File Name",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "coverholder_name",
  //     headerName: "Cover Holder Name",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "payment_id",
  //     headerName: "Payment ID",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "partner_name",
  //     headerName: "Partner Name",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "payment_type",
  //     headerName: "Payment Type",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "final_bank_account",
  //     headerName: "Final Bank Account",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "final_bank_name",
  //     headerName: "Final Bank Name",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "to_bank_account_name",
  //     headerName: "To Bank Account Name",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "to_bank_account",
  //     headerName: "To Bank Account",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "settlement_currency",
  //     headerName: "Settlement Currency",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "sum_of_final_net_premium_settlement_currency",
  //     headerName: "Sum of Final Net Premium Settlement Currency",
  //     headerAlign: "center",
  //     valueFormatter: (params) => {
  //       return numberFormatter(params.value);
  //     },
  //     width: 160,
  //   },
  //   {
  //     field: "sum_of_rebate",
  //     headerName: "Sum of Rebate",
  //     headerAlign: "center",
  //     valueFormatter: (params) => {
  //       return numberFormatter(params.value);
  //     },
  //     width: 160,
  //   },
  //   {
  //     field: "sum_of_net_payment",
  //     headerName: "Sum of Net Payment",
  //     headerAlign: "center",
  //     valueFormatter: (params) => {
  //       return numberFormatter(params.value);
  //     },
  //     width: 160,
  //   },

  // ];

  // const syndicatePaymentColumns = [
  //   {
  //     headerName: "",
  //     headerAlign: "center",
  //     flex: 0.1,
  //     type: "actions",
  //     renderCell: (params) => (
  //       <>
  //         <Checkbox
  //           // checked={selectedCheckboxIds?.includes(params?.row?.id)}
  //           onChange={(e) => handleRadioChange(e)}
  //           value={params?.row?.id}
  //           name="file-selection"
  //           style={{ color: "black" }}
  //         />
  //       </>
  //     ),
  //   },
  //   {
  //     field: "bdx_file_name",
  //     headerName: "BDX File Name",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "coverholder_name",
  //     headerName: "Cover Holder Name",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "payment_id",
  //     headerName: "Payment ID",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "partner_name",
  //     headerName: "Partner Name",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "payment_type",
  //     headerName: "Payment Type",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "final_bank_account",
  //     headerName: "Final Bank Account",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "final_bank_name",
  //     headerName: "Final Bank Name",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "to_bank_account_name",
  //     headerName: "To Bank Account Name",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "to_bank_account",
  //     headerName: "To Bank Account",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "settlement_currency",
  //     headerName: "Settlement Currency",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "sum_of_final_net_premium_settlement_currency",
  //     headerName: "Sum of Final Net Premium Settlement Currency",
  //     headerAlign: "center",
  //     valueFormatter: (params) => {
  //       return numberFormatter(params.value);
  //     },
  //     width: 160,
  //   },
  //   {
  //     field: "sum_of_rebate",
  //     headerName: "Sum of Rebate",
  //     headerAlign: "center",
  //     valueFormatter: (params) => {
  //       return numberFormatter(params.value);
  //     },
  //     width: 160,
  //   },
  //   {
  //     field: "sum_of_net_payment",
  //     headerName: "Sum of Net Payment",
  //     headerAlign: "center",
  //     valueFormatter: (params) => {
  //       return numberFormatter(params.value);
  //     },
  //     width: 160,
  //   },
  // ];

  // DEMO: money polish — $ prefix, bold, red negatives, muted zero
  const renderMoneyCell = (value, { bold = false } = {}) => {
    const num = Number(value);
    if (!Number.isFinite(num) || num === 0) {
      return <span style={{ color: "#9ca3af" }}>—</span>;
    }
    const color = num < 0 ? "#f44336" : bold ? "#111827" : "#374151";
    return (
      <span style={{ color, fontWeight: bold ? 700 : 500, fontVariantNumeric: "tabular-nums" }}>
        {num < 0 ? "-" : ""}${numberFormatter(Math.abs(num))}
      </span>
    );
  };

  const Columns = [
    // {
    //   headerName: "",
    //   headerAlign: "center",
    //   flex: 0.1,
    //   type: "actions",
    //   renderCell: (params) => (
    //     <>
    //       <Checkbox
    //         // checked={selectedCheckboxIds?.includes(params?.row?.id)}
    //         onChange={(e) => handleRadioChange(e)}
    //         value={params?.row?.id}
    //         name="file-selection"
    //         style={{ color: "black" }}
    //       />
    //     </>
    //   ),
    // },
    {
      field: "payment_id",
      headerName: "Payment ID",
      headerAlign: "center",
      width: 160,
    },
    {
      field: "bdx_file_name",
      headerName: "BDX File Name",
      headerAlign: "center",
      // DEMO: narrower file column (tooltip shows full name)
      width: 280,
      // DEMO: tooltips
      renderCell: (params) => (
        <Tooltip title={params.row?.bdx_file_name || ""}>
          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {params.row?.bdx_file_name}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "coverholder_name",
      headerName: "Cover Holder Name",
      headerAlign: "center",
      width: 160,
      // DEMO: tooltips
      renderCell: (params) => (
        <Tooltip title={params.row?.coverholder_name || ""}>
          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {params.row?.coverholder_name}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "partner_name",
      headerName: "Partner Name",
      headerAlign: "center",
      width: 160,
      // DEMO: tooltips
      renderCell: (params) => (
        <Tooltip title={params.row?.partner_name || ""}>
          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {params.row?.partner_name}
          </span>
        </Tooltip>
      ),
    },
    {
      field: "payment_type",
      headerName: "Payment Type",
      headerAlign: "center",
      align: "center",
      width: 160,
      // DEMO: payment type chip in-row
      renderCell: (params) => {
        const type = params.row?.payment_type;
        if (!type) return <>—</>;
        const { color, bg } = getPaymentTypePillStyle(type);
        return (
          <Chip
            label={type}
            size="small"
            sx={{
              backgroundColor: bg,
              color,
              fontWeight: "600",
              fontSize: "12px",
              height: "26px",
              borderRadius: "6px",
              border: `1px solid ${color}`,
            }}
          />
        );
      },
    },
    {
      // DEMO: bank column
      field: "bank_account",
      headerName: "Bank / Account",
      headerAlign: "center",
      width: 220,
      sortable: false,
      renderCell: (params) => {
        const bankName =
          params.row?.final_bank_name || params.row?.to_bank_account_name || "—";
        const accountCode = params.row?.final_bank_account || "—";
        return (
          // DEMO: tooltips
          <Tooltip title={`${bankName}${accountCode !== "—" ? ` · ${accountCode}` : ""}`}>
            <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1.25, py: 0.5, overflow: "hidden" }}>
              <span style={{ fontSize: "13px", fontWeight: 400, color: "#111827", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {bankName}
              </span>
              <span style={{ fontSize: "11px", color: "#6b7280", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {accountCode}
              </span>
            </Box>
          </Tooltip>
        );
      },
    },
    // DEMO: bank column — original columns hidden
    // { field: "final_bank_account", headerName: "Final Bank Account", ... },
    // { field: "final_bank_name", headerName: "Final Bank Name", ... },
    // { field: "to_bank_account_name", headerName: "To Bank Account Name", ... },
    {
      field: "to_bank_account",
      headerName: "To Bank Account",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "settlement_currency",
      headerName: "Settlement Currency",
      headerAlign: "center",
      width: 160,
    },
    {
      field: "sum_of_final_net_premium_settlement_currency",
      headerName: "Net Premium (Settlement)",
      headerAlign: "center",
      // DEMO: money polish
      align: "right",
      renderCell: (params) => renderMoneyCell(params.row?.sum_of_final_net_premium_settlement_currency),
      width: 180,
    },
    {
      field: "sum_of_rebate",
      headerName: "Sum of Rebate",
      headerAlign: "center",
      // DEMO: money polish
      align: "right",
      renderCell: (params) => renderMoneyCell(params.row?.sum_of_rebate),
      width: 160,
    },
    {
      field: "sum_of_net_payment",
      headerName: "Sum of Net Payment",
      headerAlign: "center",
      // DEMO: money polish — bold, this is the headline figure
      align: "right",
      renderCell: (params) => renderMoneyCell(params.row?.sum_of_net_payment, { bold: true }),
      width: 160,
    },
  ];

  // const rebatePaymentColumns = [
  //   {
  //     headerName: "",
  //     headerAlign: "center",
  //     flex: 0.1,
  //     type: "actions",
  //     renderCell: (params) => (
  //       <>
  //         <Checkbox
  //           // checked={selectedCheckboxIds?.includes(params?.row?.id)}
  //           onChange={(e) => handleRadioChange(e)}
  //           value={params?.row?.id}
  //           name="file-selection"
  //           style={{ color: "black" }}
  //         />
  //       </>
  //     ),
  //   },
  //   {
  //     field: "bdx_file_name",
  //     headerName: "BDX File Name",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "coverholder_name",
  //     headerName: "Cover Holder Name",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "payment_id",
  //     headerName: "Payment ID",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "partner_name",
  //     headerName: "Partner Name",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "payment_type",
  //     headerName: "Payment Type",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "final_bank_account",
  //     headerName: "Final Bank Account",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "final_bank_name",
  //     headerName: "Final Bank Name",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "to_bank_account_name",
  //     headerName: "To Bank Account Name",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "to_bank_account",
  //     headerName: "To Bank Account",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   {
  //     field: "settlement_currency",
  //     headerName: "Settlement Currency",
  //     headerAlign: "center",
  //     width: 160,
  //   },
  //   // {
  //   //   field: "sum_of_final_net_premium_settlement_currency",
  //   //   headerName: "Sum of Final Net Premium Settlement Currency",
  //   //   headerAlign: "center",
  //   //   valueFormatter: (params) => {
  //   //     return numberFormatter(params.value);
  //   //   },
  //   //   width: 160,
  //   // },
  //   {
  //     field: "sum_of_rebate",
  //     headerName: "Sum of Rebate",
  //     headerAlign: "center",
  //     valueFormatter: (params) => {
  //       return numberFormatter(params.value);
  //     },
  //     width: 160,
  //   },
  //   // {
  //   //   field: "sum_of_net_payment",
  //   //   headerName: "Sum of Net Payment",
  //   //   headerAlign: "center",
  //   //   valueFormatter: (params) => {
  //   //     return numberFormatter(params.value);
  //   //   },
  //   //   width: 160,
  //   // },
  // ];


  // const getColumnsByPaymentType = () => {
  //   let treasuryPaymentTypes = [];
  //   switch (searchFieldParams.type_of_payment) {
  //     case "Syndicate Payment":
  //       treasuryPaymentTypes = [...syndicatePaymentColumns];
  //       break;
  //     case "Internal Broking":
  //       treasuryPaymentTypes = [...partnerPaymentColumns];
  //       break;
  //     case "MGA Commission":
  //       treasuryPaymentTypes = [...commissionPaymentColumns]
  //       break;
  //     case "Rebate":
  //       treasuryPaymentTypes = [...rebatePaymentColumns]
  //       break;
  //     default:
  //       treasuryPaymentTypes = [...syndicatePaymentColumns];
  //       break;
  //   }

  //   return treasuryPaymentTypes
  // }

  const getOverallStatusList = async () => {
    const response = await instance.get(
      "payment/payment_overall_status/overall_status/"
    );
    const overall_status_list = response.data.data;
    setOverallStatuses(overall_status_list);
  };

  // useEffect(() => {
  //   setPaginationCount(getPaginationCount(pageState?.total, pageState?.pageSize));
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [pageState?.total, pageState?.page, pageState?.pageSize]);

  // UseEffect
  useEffect(() => {
    if (isClearPerformed) {
      loadData();
      // load data after clear
      setIsClearPerformed(false);
      setIsSearchPerformed(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isClearPerformed]);

  useEffect(() => {
    if (!isClearPerformed) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageState?.pageSize, pageState?.page]);

  useEffect(() => {
    setPaginationCount(getPaginationCount(pageState?.total, pageState?.pageSize));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageState?.total, pageState?.pageSize, pageState?.page]);
  
  useEffect(() => {
    getOverallStatusList();
    loadPartners();
    fetchBindingAgreementData();
    // loadData();
    getCurrencies();
    fetchPaymentIDData();
    fetchBankData();
  }, [])

  const handleEnter = (e) => {
    if (e.code === "Enter") {
      loadSearchTxnData();
    }
  };

  const isFilterBtnDisable = () => {
    const {
      type_of_payment,
      category,
      policy_no,
      bdx_file_name,
      payment_id,
      final_bank,
      settlement_currency,
      scm_type,
      partner,
      placing_broker,
      overall_status,
    } = searchFieldParams;

    const hasAnyFilter =
      !!type_of_payment ||
      !!category ||
      !!policy_no ||
      !!bdx_file_name ||
      !!payment_id ||
      !!final_bank ||
      !!settlement_currency ||
      !!scm_type ||
      !!partner ||
      !!placing_broker ||
      (Array.isArray(overall_status) && overall_status.length > 0);

    return !hasAnyFilter;
  };

  // Prepare filter configs for CommonFilterSidebar (same layout pattern as Exception Report)
  const filterConfigs = [
    {
      type: "custom",
      content: (
        <>
          <Typography
        sx={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#000",
              marginBottom: "12px",
        }}
          >
            Payment Type
          </Typography>
          <CommonSelect
            placeholder="Select Payment Type"
            value={searchFieldParams?.type_of_payment}
            handleChange={(event, value, reason) =>
              handleSelectDropdown("type_of_payment", value, reason, event)
            }
            options={paymentTypes?.map((option) => option) || []}
          />
        </>
      ),
    },
    {
      type: "custom",
      content: (
        <>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#000",
              marginBottom: "12px",
            }}
        >
            Category
          </Typography>
          <CommonSelect
            placeholder="Select Cash Type"
            value={searchFieldParams?.category}
            handleChange={(event, value, reason) =>
              handleSelectDropdown("category", value, reason, event)
            }
            options={categories?.map((option) => option) || []}
          />
        </>
      ),
    },
    {
      type: "custom",
      content: (
        <>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#000",
              marginBottom: "12px",
            }}
        >
            Final Bank
          </Typography>
          <CommonSelect
              placeholder="Select Final Bank"
              value={searchFieldParams?.final_bank}
              handleChange={(event, value, reason) =>
              handleSelectDropdown("final_bank", value, reason, event)
              }
            options={finalBanks || []}
            />
        </>
      ),
    },
    {
      type: "custom",
      content: (
        <>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#000",
              marginBottom: "12px",
            }}
        >
            Settlement Currency
          </Typography>
          <CommonSelect
              placeholder="Select Settlement Currency"
              value={searchFieldParams?.settlement_currency}
              handleChange={(event, value, reason) =>
              handleSelectDropdown("settlement_currency", value, reason, event)
              }
            options={currencies?.map((option) => option?.currency_code) || []}
            />
        </>
      ),
    },
    {
      type: "custom",
      content: (
        <>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#000",
              marginBottom: "12px",
            }}
          >
            Payment ID
          </Typography>
          <CommonSelect
            placeholder="Select payment ID"
            value={searchFieldParams?.payment_id}
            handleChange={(event, value, reason) =>
              handleSelectDropdown("payment_id", value, reason, event)
            }
            options={paymentID || []}
          />
        </>
      ),
    },
    {
      type: "textInput",
      label: "Policy No",
      placeholder: "Type policy no",
      value: searchFieldParams.policy_no,
      onChange: (value) => {
        if (!value) {
          handleClearSearchList();
        }
        setSearchFieldsParams((v) => ({
          ...v,
          policy_no: value,
        }));
      },
      onKeyUp: handleEnter,
    },
    {
      type: "textInput",
      label: "BDX File Name",
      placeholder: "Type bdx file name",
      value: searchFieldParams.bdx_file_name,
      onChange: (value) => {
        if (!value) {
          handleClearSearchList();
        }
        setSearchFieldsParams((v) => ({
          ...v,
          bdx_file_name: value,
        }));
      },
      onKeyUp: handleEnter,
    },
  ];

  // DEMO: payment type summary
  const paymentTypeSummary = Object.entries(
    (pageState?.data ?? []).reduce((acc, row) => {
      const type = String(row?.payment_type ?? "").trim();
      if (!type) return acc;
      acc[type] = (acc[type] || 0) + 1;
      return acc;
    }, {}),
  );

  // DEMO: payment type summary — color per type
  const getPaymentTypePillStyle = (type) => {
    const lower = String(type ?? "").toLowerCase();
    if (lower.includes("commission")) {
      return { color: "#4caf50", bg: "rgba(76, 175, 80, 0.1)" };
    }
    if (lower.includes("rebate")) {
      return { color: "#ff9800", bg: "rgba(255, 152, 0, 0.1)" };
    }
    if (lower.includes("syndicate")) {
      return { color: "#9c27b0", bg: "rgba(156, 39, 176, 0.1)" };
    }
    return { color: "#1672DE", bg: "rgba(22, 114, 222, 0.1)" };
  };

  // DEMO: KPI line — totals from loaded rows
  const loadedRows = pageState?.data ?? [];
  const kpiPaymentCount = loadedRows.length;
  const kpiNetPayment = loadedRows.reduce((sum, row) => {
    const n = Number(row?.sum_of_net_payment);
    return sum + (Number.isFinite(n) ? n : 0);
  }, 0);
  const kpiCurrencies = [
    ...new Set(
      loadedRows
        .map((row) => String(row?.settlement_currency ?? "").trim())
        .filter(Boolean),
    ),
  ];

  // DEMO: selection action bar
  const selectedRows = loadedRows.filter((row) => selectedRecords?.includes(row?.id));
  const selectedNetPayment = selectedRows.reduce((sum, row) => {
    const n = Number(row?.sum_of_net_payment);
    return sum + (Number.isFinite(n) ? n : 0);
  }, 0);

  return (
    <div style={Container}>
      {/* Filter Sidebar */}
      <CommonFilterSidebar
        isOpen={filterSidebarOpen}
        filterConfigs={filterConfigs}
        onApplyFilters={loadSearchTxnData}
        onClearFilters={handleClearSearchList}
        isLoading={pageState?.isLoading || isApiProgressBar}
        isFilterDisabled={isFilterBtnDisable()}
      />

      {/* Main Content Area */}
      <Box className="main-content-area">
        <Box className="page-header-container">
          <Box>
            <Typography variant="h5" className="page-heading">
              No Var - Pay Release
            </Typography>
            {/* DEMO: role context line */}
            <Typography sx={{ fontSize: "12px", color: "#6b7280", marginTop: "4px", fontWeight: 500 }}>
              Finance-ready — release matched payments
            </Typography>
            {/* DEMO: KPI line */}
            {kpiPaymentCount > 0 && (
              <Typography
                sx={{
                  fontSize: "12px",
                  color: "#6b7280",
                  marginTop: "4px",
                  fontWeight: 500,
                }}
              >
                {kpiPaymentCount} payment{kpiPaymentCount === 1 ? "" : "s"} · $
                {numberFormatter(kpiNetPayment)} net payment
                {kpiCurrencies.length > 0
                  ? ` · ${kpiCurrencies.join(", ")} settlement`
                  : ""}
              </Typography>
            )}
          </Box>
          <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
            {/* DEMO: contextual action — header button hidden while rows are selected */}
            {selectedRecords?.length === 0 && (
              <CommonButton
                text="Initiate Payment"
                className="bankStatementInitiateBtn"
                hoverColor="#EE3F00"
                disabled={selectedRecords?.length === 0 || isButtonClicked}
                handleClick={handleInitiatePaymentClick}
                isLoading={isButtonClicked}
              />
            )}
            <IconButton
              onClick={() => setFilterSidebarOpen(!filterSidebarOpen)}
              className="filter-toggle-button"
            >
              <FilterListIcon />
            </IconButton>
          </Box>
        </Box>

        {/* DEMO: guided workflow path */}
        <DemoWorkflowNav activeStep={2} />

        {/* DEMO: selection action bar */}
        {selectedRecords?.length > 0 && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "12px",
              flexWrap: "wrap",
              marginBottom: "12px",
              padding: "10px 16px",
              borderRadius: "10px",
              backgroundColor: "rgba(22, 114, 222, 0.08)",
              border: "1px solid rgba(22, 114, 222, 0.3)",
            }}
          >
            <Typography sx={{ fontSize: "13px", color: "#1f2937", fontWeight: 500 }}>
              <span style={{ fontWeight: 700, color: "#1672DE" }}>
                {selectedRecords.length}
              </span>{" "}
              item{selectedRecords.length === 1 ? "" : "s"} selected
              <span style={{ margin: "0 8px", color: "#9ca3af" }}>·</span>
              Net payment{" "}
              <span style={{ fontWeight: 700, color: "#111827" }}>
                ${numberFormatter(selectedNetPayment)}
              </span>
            </Typography>
            <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <Button
                onClick={() => setSelectedRecords([])}
                sx={{ color: "#6b7280", textTransform: "none", fontSize: "13px" }}
              >
                Clear selection
              </Button>
              <CommonButton
                text="Initiate Payment"
                className="bankStatementInitiateBtn"
                hoverColor="#EE3F00"
                disabled={selectedRecords?.length === 0 || isButtonClicked}
                handleClick={handleInitiatePaymentClick}
                isLoading={isButtonClicked}
              />
            </Box>
          </Box>
        )}

        {/* DEMO: payment type summary */}
        {paymentTypeSummary.length > 0 && (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
              alignItems: "center",
              marginBottom: "12px",
            }}
          >
            {paymentTypeSummary.map(([type, count]) => {
              const { color, bg } = getPaymentTypePillStyle(type);
              return (
                <Chip
                  key={type}
                  label={`${type} ×${count}`}
                  size="small"
                  sx={{
                    backgroundColor: bg,
                    color,
                    fontWeight: "600",
                    fontSize: "12px",
                    height: "28px",
                    borderRadius: "6px",
                    border: `1px solid ${color}`,
                  }}
                />
              );
            })}
          </Box>
        )}

        <Box
          sx={{
            flex: 1,
          display: "flex",
            flexDirection: "column",
            minHeight: 0,
            position: "relative",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            overflow: "visible",
            transition: "all 0.3s ease",
            border: "1px solid #e8eaf0",
            paddingBottom: "10px",
            "&:hover": {
              boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
            },
        }}
      >
        <DataGrid
          className={classes.pagination}
          loading={pageState?.isLoading || isApiProgressBar}
          rows={pageState?.data ?? []}
          rowCount={pageState?.total}
          getRowId={(row) => row?.id}
          columns={Columns}
          checkboxSelection
          selectionModel={selectedRecords}
          onSelectionModelChange={handleSelectionModelChange}
          disableRowSelectionOnClick
          keepNonExistentRowsSelected
          pagination
          paginationMode="server"
          disableSelectionOnClick
          page={pageState.page - 1}
          pageSize={pageState?.pageSize ?? 25}
          onPageSizeChange={(newPageSize) => {
            return setPageState((old) => {
              setPaginationCount(getPaginationCount(pageState?.total, newPageSize));
              return { ...old, pageSize: newPageSize, page: 1 };
            });
          }}
          rowsPerPageOptions={[10, 25, 50, 100]}
          sx={{
              border: "none",
              flex: 1,
              minHeight: 0,
              "& .MuiDataGrid-root": {
                border: "none",
                height: "100%",
              },
              "& .MuiDataGrid-main": {
                height: "100%",
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "#f1f1f1",
                  borderRadius: "10px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#1672DE",
                  borderRadius: "10px",
                  "&:hover": {
                    background: "#1565c0",
                  },
                },
              },
              // DEMO: horizontal scrollbar — subtle, still reachable
              "& .MuiDataGrid-virtualScroller": {
                overflowX: "auto !important",
                "&::-webkit-scrollbar": {
                  width: "6px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "transparent",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#cbd5e1",
                  borderRadius: "10px",
                  "&:hover": {
                    background: "#94a3b8",
                  },
                },
                scrollbarColor: "#cbd5e1 transparent",
                scrollbarWidth: "thin",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f8f9fa",
                borderBottom: "2px solid #e0e0e0",
                minHeight: "52px !important",
                maxHeight: "52px !important",
              },
              "& .MuiDataGrid-columnHeader": {
                backgroundColor: "transparent",
                fontWeight: "600",
                color: "#1672DE",
                fontSize: "14px",
                padding: "8px 12px",
                borderBottom: "none",
                overflow: "visible",
                "&:focus": {
                  outline: "none",
                },
                "&:focus-within": {
                  outline: "none",
                },
                // DEMO: header fit — tighter type so long titles wrap without clipping
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "600",
                  fontSize: "13px",
                  overflow: "visible",
                  textOverflow: "clip",
                  whiteSpace: "normal",
                  lineHeight: "1.25",
                  width: "100%",
                },
                "& .MuiDataGrid-sortIcon": {
                  color: "#1672DE",
                },
                "& .MuiDataGrid-menuIcon": {
                  color: "#1672DE",
                },
              },
              "& .MuiDataGrid-columnHeader[data-field='__check__']": {
                minWidth: "58px !important",
                maxWidth: "58px !important",
                padding: "0 8px",
                justifyContent: "center",
                "& .MuiDataGrid-columnHeaderTitleContainer": {
                  justifyContent: "center",
                },
                "& .MuiCheckbox-root": {
                  padding: "4px",
                  color: "#1672DE",
                  "&.Mui-checked": {
                    color: "#1672DE",
                  },
                },
              },
              "& .MuiDataGrid-cell[data-field='__check__']": {
                minWidth: "58px !important",
                maxWidth: "58px !important",
                padding: "0 8px",
                justifyContent: "center",
                "& .MuiCheckbox-root": {
                  padding: "4px",
                  color: "#1672DE",
                  "&.Mui-checked": {
                    color: "#1672DE",
                  },
                },
              },
              "& .MuiCheckbox-root": {
                color: "#1672DE",
                "&.Mui-checked": {
                  color: "#1672DE",
                },
              },
              "& .MuiDataGrid-row": {
                transition: "all 0.2s ease",
                borderBottom: "1px solid #f0f0f0",
                "&:hover": {
                  backgroundColor: "rgba(22, 114, 222, 0.04)",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                },
                "&.Mui-selected": {
                  backgroundColor: "rgba(22, 114, 222, 0.12)",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.18)",
                  },
                },
                "&:nth-of-type(even)": {
                  backgroundColor: "#fafafa",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.04)",
                  },
                },
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid #f0f0f0",
                padding: "12px 16px",
                fontSize: "13px",
                color: "#333",
                display: "flex",
                alignItems: "center",
                "&:focus": {
                  outline: "none",
                },
                "&:focus-within": {
                  outline: "none",
                },
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "2px solid #e0e0e0",
                backgroundColor: "#f8f9fa",
                minHeight: "48px",
                maxHeight: "48px",
                paddingBottom: "8px",
                paddingTop: "8px",
                paddingLeft: "16px",
                paddingRight: "16px",
                position: "relative",
                zIndex: 1,
                "& .MuiTablePagination-root": {
                  color: "#666",
                  paddingRight: "16px",
                  margin: 0,
                  minHeight: "32px",
                },
                "& .MuiTablePagination-selectLabel": {
                  fontSize: "13px",
                  margin: 0,
                },
                "& .MuiTablePagination-displayedRows": {
                  fontSize: "13px",
                  margin: 0,
                },
                "& .MuiTablePagination-actions": {
                  marginLeft: "8px",
                  "& .MuiIconButton-root": {
                    padding: "4px",
                  },
                },
                "& .MuiTablePagination-select": {
                  margin: "0 8px",
                  padding: "4px 8px",
                },
                "& .MuiTablePagination-toolbar": {
                  minHeight: "32px",
                  padding: 0,
                },
              },
              "& .MuiDataGrid-toolbarContainer": {
                padding: "12px 16px",
                backgroundColor: "#f8f9fa",
                borderBottom: "1px solid #e0e0e0",
                "& .MuiButton-root": {
                  color: "#1672DE",
                  fontSize: "13px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.1)",
                  },
                },
              },
              "& .MuiDataGrid-loadingOverlay": {
                backgroundColor: "rgba(255, 255, 255, 0.8)",
              },
            "& .MuiDataGrid-columnHeader[data-field='File_Name']": {
              minWidth: toggle?.isOpen
                ? "170.137px !important"
                : "198px !important",
            },
          }}
          components={{
            Toolbar: GridToolbarContainer,
            NoRowsOverlay: () => (
                <Stack
                  height="100%"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ color: "#999" }}
                >
                  <Typography variant="body2" sx={{ color: "#999" }}>
                    No records
                  </Typography>
              </Stack>
            ),
          }}
        />
        <Stack
            sx={{
            position: "absolute",
              bottom: "16px",
              right: "20px",
              zIndex: 10,
              backgroundColor: "#f8f9fa",
              padding: "4px 8px",
              borderRadius: "4px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <CommonPaginationContainer
            count={paginationCount + 1}
            pageState={pageState}
            setPageState={setPageState}
          />
        </Stack>
        </Box>
      </Box>

      {/* DEMO: initiate payment */}
      <Dialog
        open={isInitiatePaymentDialogOpen}
        onClose={handleCancelInitiatePayment}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600, fontSize: "16px" }}>
          Confirm Initiate Payment
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ fontSize: "14px", color: "#374151" }}>
            Initiate payment for {selectedRecords?.length ?? 0} selected item
            {(selectedRecords?.length ?? 0) === 1 ? "" : "s"}?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ padding: "12px 24px 20px" }}>
          <Button onClick={handleCancelInitiatePayment} sx={{ color: "#6b7280" }}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmInitiatePayment}
            variant="contained"
            sx={{
              backgroundColor: "#1672DE",
              "&:hover": { backgroundColor: "#1565c0" },
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PayoutSummary;
